<template>
  <div class="rewardFee">
    <div class="rewardMain">
      <div class="feeTit">服务消耗奖励配置</div>
      <div class="tips">注：此处为门店全职技师的服务消耗奖励（以顾客实付金额为准）</div>
      <el-table
        v-if="tableData && tableData.length > 0"
        :data="tableData"
        ref="multipleTable"
        :cell-class-name="tableRowClassName"
        class="myMemTable"
        style="width: 100%"
        :header-cell-style="{background:'#EFF1F5'}"
      >
        <el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
        <el-table-column align="center" prop="postId" label="岗位名称">
          <template slot-scope="scope">{{scope.row.postId | filterPostId(infolist.postIdData) | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="isTeam" label="提成范围">
          <template slot-scope="scope">{{scope.row.isTeam=='1'?'团队提成':(scope.row.isTeam =='0'?'个人提成':'--')}}</template>
        </el-table-column>
        <el-table-column align="center" prop="currentFeeSet" label="当前服务奖励/元" width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.currentFeeSet && scope.row.currentFeeSet.feeSetDetailList && scope.row.currentFeeSet.feeSetDetailList.length > 0">
              <div class="sale" v-for="(i,index) in scope.row.currentFeeSet.feeSetDetailList" :key="index">
                <label>{{i.bottom}}{{(index == scope.row.currentFeeSet.feeSetDetailList.length-1)?'+':'-'}}{{i.top}}：</label>
                <span class="redFont">{{i.manualFee}}%</span>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="futureFeeSet" label="未生效服务奖励/元" width="220">
          <template slot-scope="scope">
            <template v-if="scope.row.futureFeeSet && scope.row.futureFeeSet.feeSetDetailList && scope.row.futureFeeSet.feeSetDetailList.length > 0">
              <div class="sale" v-for="(i,index) in scope.row.futureFeeSet.feeSetDetailList" :key="index">
                <label>{{i.bottom}}{{(index == scope.row.futureFeeSet.feeSetDetailList.length-1)?'+':'-'}}{{i.top}}：</label>
                <span class="redFont">{{i.manualFee}}%</span>
              </div>
            </template>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="startDate" label="生效时间" width="140">
          <template slot-scope="scope">{{scope.row.futureFeeSet ? scope.row.futureFeeSet.startDate:(scope.row.currentFeeSet&&scope.row.currentFeeSet.startDate) | formatDateLine | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="modTime" label="最近修改时间" width="150">
          <template slot-scope="scope">{{scope.row.futureFeeSet ? (scope.row.futureFeeSet.modTime?scope.row.futureFeeSet.modTime:scope.row.futureFeeSet.createTime):(scope.row.currentFeeSet?(scope.row.currentFeeSet.modTime?scope.row.currentFeeSet.modTime:scope.row.currentFeeSet.createTime):'--') | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" prop="mender" label="修改人">
          <template slot-scope="scope">{{scope.row.futureFeeSet ? (scope.row.futureFeeSet.mender?scope.row.futureFeeSet.mender:scope.row.futureFeeSet.creator):(scope.row.currentFeeSet?(scope.row.currentFeeSet.mender?scope.row.currentFeeSet.mender:scope.row.currentFeeSet.creator):'--') | filterRow}}</template>
        </el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button size="mini" type="danger" @click="editPro(scope.row)">修改</el-button>
          </template>
        </el-table-column>
      </el-table>
      <template v-else>
        <div class="emptys">查不到服务奖励信息！再核对一下试试</div>
      </template>
    </div>

    <el-dialog title="修改服务奖励" :visible.sync="dialogTableVisible" :center="true" width="700px" :before-close="handleClose">
      <!-- 修改销售提成 -->
      <editRoyalty :reward="true" @closeDialog="closeDialog" :cueRowData='cueRowData' :openFlag="openFlag"/>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import editRoyalty from "./editRoyalty";
import { feeSetList } from "@/api";
import infolist from '@/assets/js/info'
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components: {
    editRoyalty
  },
  data() {
    return {
      tableData: [],
      form: {},
      fullscreenLoading: false,
      dialogTableVisible: false, //修改手工费弹窗
      infolist:infolist,
      cueRowData:'',//当前选中的数据
      openFlag:false,
    };
  },
  created() {
    this.search();
  },
  methods: {
    async search(val) {
      this.fullscreenLoading = true;
      let res = await feeSetList({
        feeType:2
      });
      this.fullscreenLoading = false;
      if (res.data&&res.data.length == 0) {
        this.mySearchflag = true;
      }
      this.tableData = res.data;
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
      if (rowIndex % 2 == 1) {
        return "highLight";
      }
      return "";
    },
    editPro(rowData) {
      // 修改
      this.dialogTableVisible = true;
      this.cueRowData = rowData;
      this.openFlag = false;
    },
    closeDialog(val) {
      this.dialogTableVisible = val;
      this.openFlag = true;
      this.search();
    },
    handleClose() {
      // 弹框数据清空
      this.closeDialog(false);
    }
  }
};
</script>
<style lang="less" scoped>
.rewardMain {
  padding: 25px 0;
  .feeTit {
    font-weight: bold;
    font-size: 20px;
    text-align: center;
    margin-bottom: 10px;
  }
  .tips {
    color: #f83b56;
    text-align: left;
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #d5d9e3;
    .sale {
      label {
        text-align: right;
        width: 110px;
        display: inline-block;
      }
    }
    .redFont {
      color: #f83b56; //表格内红色字
    }
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
    .tableGoods {
      .myTitle {
        width: 100%;
        text-align: center;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .el-form-item {
      margin-bottom: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.rewardFee {
  .el-dialog__title {
    font-weight: bold;
  }
}
.myMemTable {
  .mySortTab {
    padding: 0;
    .el-form-item__content {
      .el-input {
        width: 60px;
        .el-input__inner {
          text-align: center;
        }
      }
      .el-form-item__error {
        position: relative;
        white-space: nowrap;
      }
    }
  }
  .el-input__inner,
  .el-input__inner:focus {
    border: 1px solide #f83b56;
    border-color: #f83b56;
  }
  .el-table__header {
    background: rgb(239, 241, 245);
  }
  .highLight {
    background: #eff1f5;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/basicDataCenter/rewardFee.vue